import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { PartnerAuthProvider, usePartnerAuth } from './auth';
import Shell from './components/Shell';
import Login from './pages/Login';
import Register from './pages/Register';
import RegisterPending from './pages/RegisterPending';
import Impersonate from './pages/Impersonate';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';

function Guarded({ children }) {
  const { partner, loading } = usePartnerAuth();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface-page text-sm text-ink-muted">
        Loading…
      </div>
    );
  }
  if (!partner) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function App() {
  return (
    <PartnerAuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/register/pending" element={<RegisterPending />} />
          <Route path="/auth/impersonate" element={<Impersonate />} />

          {/* Protected routes — wrapped in Shell */}
          <Route
            path="/"
            element={
              <Guarded>
                <Shell />
              </Guarded>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="products" element={<Products />} />
            <Route path="products/:mira_sku" element={<ProductDetail />} />
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        <Toaster position="top-right" />
      </Router>
    </PartnerAuthProvider>
  );
}

export default App;
